(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/favorites/assets/javascripts/views/gamefavorites.js') >= 0) return;  svs.modules.push('/components/sport/favorites/assets/javascripts/views/gamefavorites.js'); 
'use strict';

(function(Backbone, _, svs) {
  svs = svs || {};
  svs.sport = svs.sport || {};
  svs.sport.views = svs.sport.views || {};

  svs.sport.views.GameFavoriteGlobalEvents = new Marionette.Object();

  svs.sport.views.GameFavorites = Backbone.View.extend({
    defaults: function() {
      this.favoriteData = {};
      this.hasFavorites = false;
    },
    showFavoriteStar: function() {
      var isSelfService = svs.utils.ns.isNamespace(
        'svs.core.config.data.svsconfig.isSelfService'
      )
        ? svs.core.config.data.svsconfig.isSelfService
        : false;

      if (!isSelfService) {
        if (this.options.contextmenu) {
          if (this.hasFavorites) {
            this.contextMenu('toggleFavoriteOn', this.openFavorite, this);
          } else {
            this.contextMenu('toggleFavoriteOff', this.openFavorite, this);
          }
        } else {
          this.favoriteButton = svs.sport.favorites.templates.favorite_button({
            hasFavorites: false
          });
        }
      }
    },
    initialize: function(options) {
      this.options = options;

      _.bindAll(this, 'onModelReset');

      if ((options || {}).sport) {
        this.sport = options.sport;
        this.initListeners();
      }
      this.initFavorites(false);
      this.showFavoriteStar();
    },
    tagName: 'div',
    events: {},
    render: function() {
      var self = this;

      this.showFavoriteStar();
      $(this.$el).empty();
      this.favoriteData.checkboxStyle = this.options.checkboxstyle || '';
      this.$el.html(
        svs.sport.favorites.templates.editmatchfavorites(this.favoriteData)
      );
      this.$el[0].offsetHeight; 
      setTimeout(function() {
        self.delegateEvents(
          _.extend(self.events, {
            'click label[data-favorite]': self.toggleFavorite
          })
        );
        return self;
      }, 1);
    },

    initListeners: function() {
      if (this.sport) {
        this.listenTo(this.sport, 'init-favorites', this.onGetFavorites);
        this.listenTo(this.sport, 'get-favorites', this.onGetFavorites);
        this.listenTo(this.sport, 'change-favorites', this.onChangeFavorites);
        this.listenTo(this.sport, 'remove-favorites', this.onRemoveFavorites);
      }
    },

    initFavorites: function(showlogin) {
      if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        if (showlogin) {
          svs.components.customer_login.login();
        }
      } else {
        if (!svs.sport.favorites.models.favorites) {
          this.onGetFavorites(new svs.sport.favorites.models.Favorites());
        } else {
          this.onGetFavorites(svs.sport.favorites.models.favorites);
        }
      }
    },

    onGetFavorites: function(favorites) {
      this.model = favorites;

      this.listenTo(this.model, 'reset', this.onModelReset);

      this.parseMatch();
      this.checkHasFavorites();
    },

    onModelReset: function() {
      this.parseMatch();
      this.checkHasFavorites();
      this.render();
    },

    onChangeFavorites: function(hasChanged, favorites) {
      this.model = favorites;
      this.checkHasFavorites();
    },

    onRemoveFavorites: function() {
      this.doLogout();
    },

    parseMatch: function() {
      var league;
      if (this.options.match) {
        if (this.options.match.uniqueLeagueId) {
          league = {
            id: this.options.match.LeagueId,
            name: this.options.match.leagueName,
            isFavorite: !!this.model.leagues.findWhere({
              LeagueId: this.options.match.uniqueLeagueId
            })
          };
        }
        this.favoriteData = {
          homeTeam: {
            id: this.options.match.homeTeamId,
            name: this.options.match.homeTeamName,
            isFavorite: !!this.model.teams.findWhere({
              TeamId: this.options.match.homeTeamId
            })
          },
          awayTeam: {
            id: this.options.match.awayTeamId,
            name: this.options.match.awayTeamName,
            isFavorite: !!this.model.teams.findWhere({
              TeamId: this.options.match.awayTeamId
            })
          },
          league: league
        };
      } else if (this.options.event) {
        var home =
          _.findWhere(this.options.event.participants, { type: 'home' }) ||
          this.options.event.homeTeam;
        home.isFavorite = !!this.model.teams.findWhere({ TeamId: home.id });

        var away =
          _.findWhere(this.options.event.participants, { type: 'away' }) ||
          this.options.event.awayTeam;
        away.isFavorite = !!this.model.teams.findWhere({ TeamId: away.id });

        if (
          this.options.event.league &&
          this.options.event.league.uniqueLeagueId
        ) {
          league = this.options.event.league;
          league.isFavorite = !!this.model.leagues.findWhere({
            LeagueId: league.uniqueLeagueId
          });
        }

        this.favoriteData = { homeTeam: home, awayTeam: away, league: league };
      }
    },
    checkHasFavorites: function() {
      var oldstate = this.hasFavorites;
      this.hasFavorites =
        this.model.teams.findWhere({
          TeamId: parseInt(this.favoriteData.homeTeam.id, 10)
        }) ||
        this.model.teams.findWhere({
          TeamId: parseInt(this.favoriteData.awayTeam.id, 10)
        }) ||
        (this.favoriteData.league &&
          this.model.leagues.findWhere({
            LeagueId: parseInt(this.favoriteData.league.uniqueLeagueId, 10)
          }));
      if (this.hasFavorites) {
        this.hasFavorites = true;
      } else {
        this.hasFavorites = false;
      }
      if (oldstate !== this.hasFavorites) {
        this.showFavoriteStar();
        this.trigger('change');
      }
    },
    openFavorite: function(inHeight) {
      this.initFavorites(true);
      if (this.model) {
        var self = this;
        this.parseMatch();
        this.render();
        svs.components.Modal.show(
          this.$el,
          null,
          {
            title: 'Favoriter',
            headerClass: this.options.headerClass || 'bg-grey-800',
            leftButton: { visible: false },
            rightButton: {
              cssClass: this.options.buttonClass || 'btn-transparent-inverted',
              callback: function() {
                self.model.save();
                return true;
              }
            }
          },
          { forcedHeight: inHeight }
        );
      }
    },
    contextMenu: function(menu, callback, context) {
      var contextMenuData = {
        toggleFavoriteOn: {
          visible: true,
          menuType: 'button',
          icon: 'js-favorite-icon icon-star',
          callback: callback,
          context: context
        },
        toggleFavoriteOff: {
          visible: true,
          menuType: 'button',
          icon: 'js-favorite-icon icon-star-empty',
          callback: callback,
          context: context
        }
      };
      svs.components.contextualMenu.setMenuFunctionality(contextMenuData[menu]);
    },
    toggleFavorite: function(e) {
      e.preventDefault();
      var favoriteModel;
      switch ($(e.currentTarget).data('favorite')) {
        case 'homeTeam':
          if (
            this.model.teams.findWhere({
              TeamId: this.favoriteData.homeTeam.id
            })
          ) {
            favoriteModel = this.model.teams.findWhere({
              TeamId: this.favoriteData.homeTeam.id
            });
            this.model.teams.remove(favoriteModel);
          } else {
            this.model.teams.add(
              new this.model.teams.model({
                favoriteOrder: this.model.teams.length,
                TeamId: parseInt(this.favoriteData.homeTeam.id, 10)
              })
            );
          }
          break;
        case 'awayTeam':
          if (
            this.model.teams.findWhere({
              TeamId: this.favoriteData.awayTeam.id
            })
          ) {
            favoriteModel = this.model.teams.findWhere({
              TeamId: this.favoriteData.awayTeam.id
            });
            this.model.teams.remove(favoriteModel);
          } else {
            this.model.teams.add(
              new this.model.teams.model({
                favoriteOrder: this.model.teams.length,
                TeamId: parseInt(this.favoriteData.awayTeam.id, 10)
              })
            );
          }
          break;
        case 'league':
          if (
            this.model.leagues.findWhere({
              LeagueId: this.favoriteData.league.uniqueLeagueId
            })
          ) {
            favoriteModel = this.model.leagues.findWhere({
              LeagueId: this.favoriteData.league.uniqueLeagueId
            });
            this.model.leagues.remove(favoriteModel);
          } else {
            this.model.leagues.add(
              new this.model.leagues.model({
                favoriteOrder: this.model.leagues.length,
                LeagueId: this.favoriteData.league.uniqueLeagueId
              })
            );
          }
          break;
        default:
      }
      this.parseMatch();
      this.checkHasFavorites();
      this.render();
    },

    doLogout: function() {
      if (this.model) {
        this.model = null;
        this.hasFavorites = false;
        this.trigger('change');
      }
    },

    onClose: function() {
      this.stopListening();

      delete this.$el;
      delete this.el;
    }
  });
})(Backbone, _, svs);

 })(window);